export const RESET = 'USERDATAFIRM_UPDATE_RESET'
export const SET_ERROR = 'USERDATAFIRM_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'USERDATAFIRM_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'USERDATAFIRM_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'USERDATAFIRM_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'USERDATAFIRM_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'USERDATAFIRM_UPDATE_UPDATE_RETRIEVED'
